module.exports = __webpack_public_path__ + "static/media/tugga.dd23f14e.mp3";